
export default {

    //400详情查看埋点
    track400Details(startTime,user){
        const endTime = Date.now();
        const duration = endTime - startTime; // 毫秒
        console.log("duration", duration);
        console.log("username", user.username);
        console.log("usercode", user.usercode);
        const data = {
            username: user.username,
            usercode: user.usercode,
            title: "查看400详情",
            type:"PC",
            startTime: startTime,
            endTime: endTime,
            duration: duration,
        };
        window.__KITCHEN_GOD__.log("track400Details", data);

    },

    //400列表查询埋点
    track400ManageList(startTime,user){
        const endTime = Date.now();
        const duration = endTime - startTime; // 毫秒
        console.log("duration", duration);
        console.log("username", user.username);
        console.log("usercode", user.usercode);
        const data = {
            username: user.username,
            usercode: user.usercode,
            title: "查询400列表",
            type:"PC",
            startTime: startTime,
            endTime: endTime,
            duration: duration,
        };
        window.__KITCHEN_GOD__.log("track400ManageList", data);

    },

}
